import { useLocation, useNavigate } from 'react-router'
import { cn } from '@/shared/lib/utils'
import { CreditCard, Gift, User, Home } from 'lucide-react'
import { useAuthStore } from '@/shared/stores/auth'

const navItems = [
  {
    label: 'Home',
    path: '/',
    icon: Home,
  },
  {
    label: 'Gift Cards',
    path: '/giftcards',
    icon: Gift,
  },
  {
    label: 'My Cards',
    path: '/orders',
    icon: CreditCard,
    requiresAuth: true,
  },
  {
    label: 'Profile',
    path: '/profile',
    icon: User,
  },
]

export function BottomNav() {
  const location = useLocation()
  const navigate = useNavigate()
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated)

  const isAuthPage = location.pathname.startsWith('/auth')
  if (isAuthPage) {
    return null
  }

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 border-t border-border bg-background/95 backdrop-blur-md md:hidden">
      <div className="mx-auto flex max-w-md items-center justify-around pb-safe">
        {navItems
          .filter((item) => !item.requiresAuth || isAuthenticated)
          .map((item) => {
            const isActive =
              item.path === '/'
                ? location.pathname === '/'
                : location.pathname === item.path || location.pathname.startsWith(item.path + '/')
            const Icon = item.icon

            return (
              <button
                key={item.path + item.label}
                onClick={() => navigate(item.path)}
                className={cn(
                  'flex flex-col items-center justify-center gap-1 px-4 py-3 transition-colors',
                  isActive ? 'text-primary' : 'text-muted-foreground hover:text-foreground'
                )}
              >
                <Icon className="h-6 w-6" strokeWidth={isActive ? 2.5 : 2} />
                <span className="text-xs font-medium">{item.label}</span>
              </button>
            )
          })}
      </div>
    </nav>
  )
}
